import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import layerReducer from '../features/layerSlice';
import mapReducer from '../features/mapSlice';
import authReducer from '../features/authSlice';
import sharedReducer from '../features/sharedSlice';
import selectionReducer from '../features/selectionSlice';
import toolbarReducer from '../features/toolbarSlice';
import drawReducer from '../features/drawSlice';
import panoReducer from '../features/panoSlice';
import searchResultReducer from '../features/searchResultSlice';
import languageReducer from '../features/languageSlice';
import importReducer from '../features/importSlice';
import firmReducer from '../features/firmSlice';
import basemapSlice from '../features/basemapSlice';

export const store = configureStore({
  reducer: {
    layer: layerReducer,
    mapState: mapReducer,
    authState: authReducer,
    sharedState: sharedReducer,
    selectionState: selectionReducer,
    toolbarState: toolbarReducer,
    drawState: drawReducer,
    panoState: panoReducer,
    searchResult: searchResultReducer,
    language: languageReducer,
    import: importReducer,
    firm: firmReducer,
    basemap: basemapSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false })
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
